import { Globe2, Coins } from "lucide-react";
import { useI18n, CURRENCIES } from "@/contexts/I18nContext";

export default function CurrencyLanguageSelector({ compact = false }) {
  const { lang, setLang, ccy, setCcy } = useI18n();
  return (
    <div className="flex items-center gap-2" data-testid="lang-ccy-selector">
      <div className="flex items-center gap-1 rounded-md border border-white/10 bg-black/40 pl-2 pr-1 py-1.5">
        <Globe2 className="w-3.5 h-3.5 text-[color:var(--dncm-cyan)]" />
        <select
          data-testid="lang-select"
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          aria-label="Language"
          className="bg-transparent text-white font-mono-d text-[10px] uppercase tracking-[0.22em] focus:outline-none cursor-pointer"
        >
          <option value="fr" className="bg-black text-white">FR</option>
          <option value="en" className="bg-black text-white">EN</option>
        </select>
      </div>
      <div className="flex items-center gap-1 rounded-md border border-white/10 bg-black/40 pl-2 pr-1 py-1.5">
        <Coins className="w-3.5 h-3.5 text-[color:var(--dncm-green)]" />
        <select
          data-testid="ccy-select"
          value={ccy}
          onChange={(e) => setCcy(e.target.value)}
          aria-label="Currency"
          className="bg-transparent text-white font-mono-d text-[10px] uppercase tracking-[0.22em] focus:outline-none cursor-pointer"
        >
          {Object.values(CURRENCIES).map((c) => (
            <option key={c.code} value={c.code} className="bg-black text-white">
              {c.code}
            </option>
          ))}
        </select>
      </div>
      {!compact && null}
    </div>
  );
}
